<template>
    <b-modal id="unit_details" ref="unit_details" hide-footer
             modal-class="modal-right modal-dialog-scrollable">
        <template v-slot:modal-title>
            <div>
                Details of<br>
                <div class="text-primary"> {{ unit.data.attributes.name }}</div>
            </div>
        </template>

        <div class="mb-4">
            <b-badge pill style="width: 58px;"
                     :variant="'info'">
                {{ "Active" }}
            </b-badge>

            <b-badge class="ml-2" pill style="width: 65px;"
                     :variant="'light'">
                {{ "Vacant" }}
            </b-badge>

            <b-badge class="ml-2" pill style="width: 58px;"
                     :variant="'primary'">
                {{ "Family" }}
            </b-badge>
        </div>

        <p class="mb-5">
            Client : <span class="font-weight-bold"></span>
        </p>

        <div class="mb-4">
            <p>
                <ListForSummary :icon="'iconsminds-building'" :title="'Facility'" :border-bottom="true"
                                :content="'18 Meridian Way, Northbridge'"/>
                <ListForSummary :icon="'iconsminds-posterous'" :title="'Floor'" :border-bottom="true"
                                :content="'7TH FLOOR'"/>
                <ListForSummary :icon="'iconsminds-calendar-4'" :title="'Registered At'"
                                :content="'07-17-2020'"/>
            </p>
        </div>

        <RadialProgressCard class="mb-4"
                            :title="'Occupancies | 150'"
                            secondary-title="Total"
                            :percent="75"
                            no-suffle=""/>

        <b-card no-body>
            <b-tabs card fade>
                <b-tab title="Comments" active>
                    <vue-perfect-scrollbar v-if="comments.length > 0" class="scroll comments-list"
                                           :settings="{ suppressScrollX: true, wheelPropagation: false }">
                        <CommentsList v-for="(comment, index) in comments" :data="comment"
                                      :key="index"/>
                    </vue-perfect-scrollbar>

                    <div v-else>
                        <p>No comments found.</p>
                    </div>
                </b-tab>

                <b-tab title="History">
                    <vue-perfect-scrollbar v-if="histories.length > 0" class="scroll histories-list"
                                           :settings="{ suppressScrollX: true, wheelPropagation: false }">
                        <HistoriesList :data="histories"/>
                    </vue-perfect-scrollbar>

                    <div v-else>
                        <p>No histories found.</p>
                    </div>
                </b-tab>
            </b-tabs>
        </b-card>


    </b-modal>
</template>

<script>
    import ListForSummary from "../../../../../components/Listing/ListForSummary";
    import RadialProgressCard from "../../../../../components/Cards/RadialProgressCard";
    import CommentsList from "../../../../../components/Listing/CommentsList";
    import HistoriesList from "../../../../../components/Listing/HistoriesList";

    export default {
        name: "UnitDetailsModal",

        components: {
            ListForSummary,
            RadialProgressCard,
            CommentsList,
            HistoriesList,
        },

        props: [
            'unit'
        ],

        data() {
            return {
                histories: [{
                    "history_id": 111,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Activated",
                            "action_by": "Demo User",
                            "action_at": "10:19 AM, 06-22-2020"
                        }
                    }
                }, {
                    "history_id": 110,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Deactivated",
                            "action_by": "Demo User",
                            "action_at": "05:32 AM, 06-15-2020"
                        }
                    }
                }, {
                    "history_id": 109,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Activated",
                            "action_by": "Demo User",
                            "action_at": "12:39 AM, 06-09-2020"
                        }
                    }
                }, {
                    "history_id": 108,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Deactivated",
                            "action_by": "Demo User",
                            "action_at": "12:19 AM, 06-09-2020"
                        }
                    }
                }, {
                    "history_id": 107,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Activated",
                            "action_by": "Demo User",
                            "action_at": "12:18 AM, 06-09-2020"
                        }
                    }
                }, {
                    "history_id": 106,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Deactivated",
                            "action_by": "Demo User",
                            "action_at": "12:17 AM, 06-09-2020"
                        }
                    }
                }, {
                    "history_id": 105,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Updated",
                            "action_by": "Demo User",
                            "action_at": "05:27 PM, 06-02-2020"
                        }
                    }
                }, {
                    "history_id": 91,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Updated",
                            "action_by": "Demo User",
                            "action_at": "05:31 PM, 05-29-2020"
                        }
                    }
                }, {
                    "history_id": 90,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Updated",
                            "action_by": "Demo User",
                            "action_at": "05:30 PM, 05-29-2020"
                        }
                    }
                }, {
                    "history_id": 87,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Updated",
                            "action_by": "Demo User",
                            "action_at": "11:45 PM, 05-27-2020"
                        }
                    }
                }, {
                    "history_id": 83,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Activated",
                            "action_by": "Demo User",
                            "action_at": "03:00 PM, 05-27-2020"
                        }
                    }
                }, {
                    "history_id": 80,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Deactivated",
                            "action_by": "Demo User",
                            "action_at": "10:12 PM, 05-26-2020"
                        }
                    }
                }, {
                    "history_id": 79,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Activated",
                            "action_by": "Demo User",
                            "action_at": "10:12 PM, 05-26-2020"
                        }
                    }
                }, {
                    "history_id": 49,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Deleted",
                            "action_by": "Demo User",
                            "action_at": "11:56 PM, 05-23-2020"
                        }
                    }
                }, {
                    "history_id": 48,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Updated",
                            "action_by": "Demo User",
                            "action_at": "11:36 PM, 05-23-2020"
                        }
                    }
                }, {
                    "history_id": 46,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Updated",
                            "action_by": "Demo User",
                            "action_at": "04:52 PM, 05-23-2020"
                        }
                    }
                }, {
                    "history_id": 50,
                    "data": {
                        "type": "vendors_histories",
                        "attributes": {
                            "action": "Created",
                            "action_by": "Demo Administrator",
                            "action_at": "11:56 PM, 04-10-2020"
                        }
                    }
                }],
                comments: [{
                    "comment_id": 71,
                    "data": {
                        "type": "vendors_comments",
                        "attributes": {
                            "comment": "[ACTIVATED] Changed",
                            "posted_by": {
                                "user_id": 60,
                                "label": "Demo User",
                                "data": {
                                    "type": "users",
                                    "attributes": {
                                        "code": "USR000060",
                                        "name": "Demo User",
                                        "gender": "Male",
                                        "email": "demo-user@example.invalid",
                                        "position": "Developer",
                                        "company": "HMS",
                                        "project": "PILOT",
                                        "image": "",
                                        "created_at": "04-11-2020",
                                        "status": "Active"
                                    }
                                },
                                "links": {"self": "\/users\/list\/60"}
                            },
                            "posted_at": "2 seconds ago"
                        }
                    }
                }, {
                    "comment_id": 55,
                    "data": {
                        "type": "vendors_comments",
                        "attributes": {
                            "comment": "One lonely comment-chan :'(",
                            "posted_by": {
                                "user_id": 60,
                                "label": "Demo User",
                                "data": {
                                    "type": "users",
                                    "attributes": {
                                        "code": "USR000060",
                                        "name": "Demo User",
                                        "gender": "Male",
                                        "email": "demo-user@example.invalid",
                                        "position": "Developer",
                                        "company": "HMS",
                                        "project": "PILOT",
                                        "image": "",
                                        "created_at": "04-11-2020",
                                        "status": "Active"
                                    }
                                },
                                "links": {"self": "\/users\/list\/60"}
                            },
                            "posted_at": "10:13 PM, 05-26-2020"
                        }
                    }
                }, {
                    "comment_id": 5,
                    "data": {
                        "type": "vendors_comments",
                        "attributes": {
                            "comment": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aut doloremque eos eum exercitationem iusto quibusdam rem. Asperiores ducimus, ea fugiat illum molestias nihil perferendis praesentium quae, quis temporibus vitae voluptates.",
                            "posted_by": {
                                "user_id": 60,
                                "label": "Demo User",
                                "data": {
                                    "type": "users",
                                    "attributes": {
                                        "code": "USR000060",
                                        "name": "Demo User",
                                        "gender": "Male",
                                        "email": "demo-user@example.invalid",
                                        "position": "Developer",
                                        "company": "HMS",
                                        "project": "PILOT",
                                        "image": "",
                                        "created_at": "04-11-2020",
                                        "status": "Active"
                                    }
                                },
                                "links": {"self": "\/users\/list\/60"}
                            },
                            "posted_at": "07:09 PM, 05-26-2020"
                        }
                    }
                }, {
                    "comment_id": 4,
                    "data": {
                        "type": "vendors_comments",
                        "attributes": {
                            "comment": "Repudiandae vero incidunt qui eius.",
                            "posted_by": {
                                "user_id": 60,
                                "label": "Demo User",
                                "data": {
                                    "type": "users",
                                    "attributes": {
                                        "code": "USR000060",
                                        "name": "Demo User",
                                        "gender": "Male",
                                        "email": "demo-user@example.invalid",
                                        "position": "Developer",
                                        "company": "HMS",
                                        "project": "PILOT",
                                        "image": "",
                                        "created_at": "04-11-2020",
                                        "status": "Active"
                                    }
                                },
                                "links": {"self": "\/users\/list\/60"}
                            },
                            "posted_at": "12:09 PM, 04-23-2020"
                        }
                    }
                }, {
                    "comment_id": 1,
                    "data": {
                        "type": "vendors_comments",
                        "attributes": {
                            "comment": "Quos quisquam voluptas vel id quia.",
                            "posted_by": {
                                "user_id": 33,
                                "label": "Demo Administrator",
                                "data": {
                                    "type": "users",
                                    "attributes": {
                                        "code": "USR000033",
                                        "name": "Demo Administrator",
                                        "gender": "Male",
                                        "email": "demo-admin@example.invalid",
                                        "position": "Database Manager",
                                        "company": "HMS",
                                        "project": "EHP",
                                        "image": "",
                                        "created_at": "09-28-2018",
                                        "status": "Active"
                                    }
                                },
                                "links": {"self": "\/users\/list\/33"}
                            },
                            "posted_at": "12:09 PM, 04-23-2020"
                        }
                    }
                }, {
                    "comment_id": 2,
                    "data": {
                        "type": "vendors_comments",
                        "attributes": {
                            "comment": "Ipsam corrupti quia quia aut sed.",
                            "posted_by": {
                                "user_id": 33,
                                "label": "Demo Administrator",
                                "data": {
                                    "type": "users",
                                    "attributes": {
                                        "code": "USR000033",
                                        "name": "Demo Administrator",
                                        "gender": "Male",
                                        "email": "demo-admin@example.invalid",
                                        "position": "Database Manager",
                                        "company": "HMS",
                                        "project": "EHP",
                                        "image": "",
                                        "created_at": "09-28-2018",
                                        "status": "Active"
                                    }
                                },
                                "links": {"self": "\/users\/list\/33"}
                            },
                            "posted_at": "12:09 PM, 04-23-2020"
                        }
                    }
                }, {
                    "comment_id": 3,
                    "data": {
                        "type": "vendors_comments",
                        "attributes": {
                            "comment": "Ea aut quae alias magni et voluptate doloribus consequatur.",
                            "posted_by": {
                                "user_id": 33,
                                "label": "Demo Administrator",
                                "data": {
                                    "type": "users",
                                    "attributes": {
                                        "code": "USR000033",
                                        "name": "Demo Administrator",
                                        "gender": "Male",
                                        "email": "demo-admin@example.invalid",
                                        "position": "Database Manager",
                                        "company": "HMS",
                                        "project": "EHP",
                                        "image": "",
                                        "created_at": "09-28-2018",
                                        "status": "Active"
                                    }
                                },
                                "links": {"self": "\/users\/list\/33"}
                            },
                            "posted_at": "12:09 PM, 04-23-2020"
                        }
                    }
                }]
            }
        },

        methods: {},
    }
</script>

<style scoped>

</style>
